
// @ts-ignore
export const isAllFixedQuantity = (prices) => !Object["values"](prices).find((p) => p.min !== p.max);
